/**操作日志 */
export default [
    {
        name: 'operationlog',
        path: 'operationlog',
        meta: { title: '操作日志' },
        component: () => import('@/pages/operationlog/index.vue')
    }
]